export default "__VITE_ASSET__CLJ8QP1d__"